import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../pages/Home/Home';
import Services from '../pages/Services/Services';
import CurriculumService from '../pages/Services/CurriculumService';
import ProfessionalService from '../pages/Services/ProfessionalService';
import AfterService from '../pages/Services/AfterService';
import WebService from '../pages/Services/WebService';
import SpecialService from '../pages/Services/SpecialService';
import AboutUs from '../pages/AboutUs/AboutUs';
import Contact from '../pages/Contact/Contact';
import Education from '../pages/Education/Education';
import Farming from '../pages/Farming/Farming';

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/*Home Page*/}
        <Route path="/" element={<Home/>} />
        <Route path= "/education" element={<Education/>} />
        <Route path="/farming" element={<Farming/>} />
        <Route path="/services" element={<Services/>} />
        <Route path="/services/c&pd" element={<CurriculumService/>}/>
        <Route path="/services/pl&ps" element={<ProfessionalService/>}/>
        <Route path="/services/asp&t" element={<AfterService/>}/>
        <Route path="/services/w&ad" element={<WebService/>}/>
        <Route path="/services/sec" element={<SpecialService/>}/>
        <Route path="/about" element={<AboutUs/>}/>
        <Route path="/contact" element={<Contact/>}/>
      </Routes>
    </Router>
  );
};

export default AppRoutes;